(() => {
  // Store the real value access
  const originalValueProperty = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');

  // Remap the former .value to a new .originalValueProperty property
  Object.defineProperty(HTMLInputElement.prototype, 'value', {
    set(value) {
      originalValueProperty.set.call(this, value);
      window.swinger.eventHub.trigger(this, 'programmatic-change');
    },
  });
})();
